import Filter from './filter'
// 一行一条，filter 移动到独立的文件中处理
export default {
    gate: 'api',
    version: '', // 默认版本
    module: '', // 默认模块
    key: '', // 设置发送数据的类型是JSON还是BLOB
    filter: function () {}, // 默认拦截过滤器
    inter: function () {}, // 默认拦截器
    list: {
    // 用户接口
        user: {
            login: { module: 'system', url: '/auth/login', filter: Filter.saveUser }, // 登录------------------------
            logout: { module: 'system', url: '/auth/logout', filter: Filter.loginOut }, // 退出------------------------
            getPhoneCode: { module: 'auth', url: '/auth/code' }, // 获取手机验证码
            getCode: { module: 'code', url: '/1/captcha/refresh' ,type:'get'}, // 获取验证码
            getTicket: { module: 'code', url: '/1/captcha/ticket' } // 获取Ticket
        },
        //栏目
        line:{
            listUserAll: { module: 'front', url: '/channel/list'  ,type:'get'}, // 
            contentList: { module: 'front', url: '/content/list' ,type:'get'}, // 内容
            contentGet: { module: 'front', url: '/content/get'  ,type:'get'}, // 内容
            contentPage: { module: 'front', url: '/content/page'  ,type:'get'}, // 内容
            resumeGet: { module: 'member', url: '/resume/get'  ,type:'get'}, // 内容
            itemList: { module: 'front', url: '/item/list'  ,type:'get'}, // 内容
            searchList:{ module: 'front', url: '/content/search'  ,type:'get'}, // 内容
        }
    }
}
